/* Поиск и сортировка каталога — в той же пилюле, что и чипы фильтров. */

export const SORTS = [
  { value: 'default', label: 'По порядку' },
  { value: 'price_asc', label: 'Сначала дешевле' },
  { value: 'price_desc', label: 'Сначала дороже' },
  { value: 'rating', label: 'По оценкам' },
  { value: 'new', label: 'Сначала новинки' },
];

export function Search({ value, onChange, placeholder = 'Поиск по каталогу' }) {
  return (
    <div className="search">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.8" />
        <path d="M16 16l4.5 4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
      <input
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      {value ? (
        <button type="button" className="search__clear" aria-label="Очистить поиск" onClick={() => onChange('')}>
          ×
        </button>
      ) : null}
    </div>
  );
}

export function Sort({ value, onChange }) {
  return (
    <select className="sort" value={value} aria-label="Сортировка" onChange={(e) => onChange(e.target.value)}>
      {SORTS.map((s) => (
        <option key={s.value} value={s.value}>{s.label}</option>
      ))}
    </select>
  );
}
